<template>
  <div class="new-dynamic-detail-dialog">
    <Popup
      :show="!!base64 && !isApp && isPublish"
      :class="{ 'poster-pop': true }"
      @hide="base64 = ''"
    >
      <div class="details">
        <slot name="topTitle" v-if="$slots.topTitle"></slot>
        <!-- 生成的图片 -->
        <div class="details-poster" v-if="base64">
          <img class="details-poster-img" :src="base64" alt="" />
        </div>
      </div>
    </Popup>
    <!-- 需要截图的内容 -->
    <div class="container">
      <div class="poster-content" ref="content">
        <h4 class="tip">分享一条觉得不错的回答，快来看看吧～</h4>
        <div class="qa-title" v-if="shareInfo.title">
          <img
            src="~images/qa/question/icon-wenhao.png"
            alt=""
            class="qa-icon"
          />
          {{ shareInfo.title }}
        </div>
        <div class="userinfo">
          <img
            v-if="
              shareInfo &&
              shareInfo.baseUserInfoVo &&
              shareInfo.baseUserInfoVo.avatar
            "
            :src="shareInfo.baseUserInfoVo.avatar | imgZip(80)"
            alt=""
            class="userinfo-avatar"
          />
          <div class="user-name">
            <div class="user-name-wrap">
              <span class="user-name-inner">
                {{ lenFilter(shareInfo.baseUserInfoVo.nickname, 3) }}
              </span>

              <ExposedLabel
                :isShowNormalTag="false"
                :showLevelName="false"
                :listType="1"
                :userIdentifyVoList="userIdentifyVoList"
                bigIcon="bigIcon"
                userLevelIcon="bigIcon"
                :userLevel="{
                  bigIcon: userLevel.bigIcon,
                  levelName: userLevel.levelName,
                  levelVal: userLevel.levelVal
                }"
              ></ExposedLabel>
            </div>
            <div v-if="identifyNameStr" class="identify-name-str">
              {{ identifyNameStr }}
            </div>
          </div>
        </div>
        <div class="actions">
          <span class="actions-each"
            >评论数<span class="DharmaTypeBebasKai actions-num">{{
              shareInfo.contentStatisticsVo.commentNum
            }}</span></span
          >
          <span class="actions-each"
            >点赞数<span class="DharmaTypeBebasKai actions-num">{{
              shareInfo.contentStatisticsVo.likeNum
            }}</span></span
          >
        </div>
        <div class="desc" v-html="insertAnswerIcon()"></div>
        <div class="more">长按扫码查看更多内容</div>
        <div class="code">
          <img :src="codeUrl" alt="" class="code-img" />
        </div>
        <div class="logo">
          <img
            src="~images/platform/dynamicDetail/icon-logo.png"
            alt=""
            class="logo-img"
          />
          <p class="logo-text">4000万人在这里获得专业帮助</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import { getRunTime } from 'lib/tools/utils.js'
let html2canvas = null
import QRCode from 'qrcode'
import Popup from 'component/common/Popup/index.vue'
import ExposedLabel from 'app/web/component/platform/exposedLabel.vue'
import { isObject } from 'utils/tool.js'
let loading = null
export default {
  components: {
    Popup,
    ExposedLabel
  },
  props: {
    // 是否发布完成跳过来的
    isPublish: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      base64: '',
      posterOnLineSrc: '',
      modelVisible: true,
      codeUrl: ''
    }
  },
  mounted() {
    html2canvas = require('html2canvas')
  },
  methods: {
    async initPoster(isLoading) {
      if (isLoading) {
        loading = this.$loading(`加载中`)
      }
      try {
        await Promise.all([this.getQrCode(), this.loadImg()])
        await this.convertToImage()
        this.posterOnLineSrc = await this.getImgUrl(this.base64)
        if (this.isApp && this.isPublish && isLoading) {
          this.handleShare()
        }
        if (loading) {
          loading.close()
        }
      } catch (err) {
        if (loading) {
          loading.close()
        }
      } finally {
        if (loading) {
          loading.close()
        }
      }
    },

    // 生成二维码
    async getQrCode() {
      if (this.codeUrl) return
      this.codeUrl = await QRCode.toDataURL(this.shareInfo.linkUrl, {
        margin: 0
      })
    },
    // 生成图片
    convertToImage() {
      let container = this.$refs['content']

      // 传入节点原始宽高
      const width = container.offsetWidth
      const height = container.offsetHeight

      // html2canvas配置项
      const ops = {
        scale: 2,
        width,
        height,
        useCORS: true,
        allowTaint: false,
        logging: false,
        backgroundColor: 'transparent',
        scrollY: 0
      }

      return html2canvas(container, ops).then(canvas => {
        // 返回图片的二进制数据
        this.base64 = canvas.toDataURL('image/png')
        return canvas.toDataURL('image/png')
      })
    },
    // 所有图片加载完成
    loadImg() {
      let img = []
      let imgList = []
      setTimeout(() => {
        let mulitImg = document.getElementsByTagName('img')
        let imgTotal = mulitImg.length
        for (let i = 0; i < imgTotal; i++) {
          img[i] = new Image()
          img[i].src = mulitImg[i].src
          imgList.push(img[i].src)
        }
        // if (imgList && imgList.length > 0) {
        //   loadImageEnd(imgList, () => {
        //     // this.convertToImage()
        //   })
        // }
      }, 10)
    },
    // 调起分享前先上传base图片获得线上资源
    _uploadImg(params) {
      let hostEnv = getRunTime(`//www.xinli001.com`)
      return axios.post(
        `${hostEnv}/ajax/ueditor.json?action=uploadimage&type=base64`,
        qs.stringify(params)
      )
    },
    getImgUrl(base64) {
      return this._uploadImg({
        upfile: base64,
        type: 'base64',
        bucket: 'xinli001-appimg',
        compress: 1
      }).then(res => {
        const { url } = res
        this.$emit('getImgUrl', url)
        return url
      })
    },
    // 分享海报
    async handleShare() {
      if (!this.base64) return
      // const loading = this.$loading(`正在分享海报`)
      try {
        const shareObj = {
          shareType: 'shareAndShowImage',
          imgUrl: this.posterOnLineSrc,
          sourcePage: '问题详情页',
          itemName: '问题详情页海报'
        }
        this.$bridge.shareReport(shareObj)
      } catch (err) {
        this.$toast('海报分享失败，请长按保存')
      } finally {
        // loading.close()
      }
    },
    // 关闭
    // close() {
    //   this.$emit('close')
    // },
    lenFilter(val, len) {
      if (!val) return
      return val.length > len
        ? Array.from(val).slice(0, len).join('') + '...'
        : val
    },
    // 插入回答图标
    insertAnswerIcon() {
      // const { description, attributeTag } = this.shareInfo
      const { description } = this.shareInfo
      if (!description) return ''

      // 移除多余的空格、首行缩进
      this.shareInfo.description = description.replace(/\s+/g, '')

      // let IconA = '',
      //   width = '',
      //   height = ''
      // if (+attributeTag === 10) {
      //   IconA = require('images/qa/anwser/icon-youzhi.png')
      //   width = '1.02667rem'
      //   height = '0.4rem'
      // }
      // if (+attributeTag === 11) {
      //   IconA = require('images/platform/topicDetail/icon-jing.png')
      //   width = '1.02667rem'
      //   height = '0.4rem'
      // }

      let IconAEl = this.shareInfo.description
      // IconAEl = `<img src='${IconA}' alt="" style="display: inline-block;width: ${width};height: ${height};vertical-align: -12%;" />${this.shareInfo.description}`
      return IconAEl
    }
  },
  computed: {
    isApp() {
      return this.$platform.isYixinliApp || this.$platform.isZiXunApp
    },
    userIdentifyVoList() {
      const { baseUserInfoVo } = this.shareInfo
      if (!baseUserInfoVo) return []
      const { userIdentifyVoList } = this.shareInfo?.baseUserInfoVo
      return userIdentifyVoList && Array.isArray(userIdentifyVoList)
        ? userIdentifyVoList
        : []
    },
    userLevel() {
      const { baseUserInfoVo } = this.shareInfo
      if (!baseUserInfoVo) return {}
      const { userLevel } = this.shareInfo?.baseUserInfoVo
      return userLevel && isObject(userLevel.level) ? userLevel.level : {}
    },
    // 其他身份列表
    identifyNameStr() {
      let Str = []
      if (this?.userIdentifyVoList) {
        this.userIdentifyVoList.map(item => {
          if (+item.isWork !== 1) {
            Str.push(item.identifyName)
          }
        })
      }
      return Str.slice(0, 3).join('/')
    },
    shareInfo() {
      return this.$store.state.qaQuestionDetail?.shareData || {}
    }
  }
}
</script>
<style lang="scss" scoped>
.new-dynamic-detail-dialog {
  ::v-deep .exposed-label {
    margin-top: 0px !important;
  }
  .details {
    text-align: center;
    &-poster {
      width: 600px;
      height: 1067px;
      z-index: 17;
      box-sizing: border-box;
      border-radius: 30px;
      img {
        width: 600px;
        height: 1067px;
        border-radius: 15px;
      }
    }
  }
  .container {
    opacity: 0;
    z-index: -1;
    position: fixed;
    width: 750px;
    // top: -100px;
    // left: -100px;
    .poster-content {
      position: relative;
      width: 750;
      height: 1334px;
      // height: 100vh;
      border-radius: 0.4rem;
      background: url('~images/platform/dynamicDetail/poster-bg.png') no-repeat;
      background-size: 100% 100%;
      padding: 100px 90px 0;
      box-sizing: border-box;
      .tip {
        font-size: 22px;
        color: #6c798c;
        line-height: 22px;
      }
    }
    .qa-title {
      font-weight: 600;
      font-size: 26px;
      color: #6c798c;
      line-height: 40px;
      margin-top: 40px;
      padding-bottom: 30px;
      border-bottom: 1px solid #eaecfa;
      .qa-icon {
        float: left;
        width: 30px;
        height: 30px;
        margin-top: 6px;
        margin-right: 12px;
        // background: url('~images/qa/question/icon-wenhao.png') no-repeat
        //   center/100% 100%;
      }
    }
    .userinfo {
      margin-top: 30px;
      display: flex;
      align-items: center;
    }
    .userinfo-avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 20px;
    }
    .user-name-wrap {
      display: flex;
      align-items: center;
    }
    .user-name-inner {
      font-size: 28px;
      line-height: 28px;
      color: #21252d;
      font-weight: 600;
      margin-right: 10px;
    }
    .identify-name-str {
      font-size: 22px;
      color: #9da3ac;
      line-height: 22px;
      margin-top: 10px;
    }
    .actions {
      margin-top: 32px;
      display: flex;
      align-items: center;
      .actions-each {
        display: flex;
        align-items: center;
        font-size: 22px;
        color: #434c5c;
        line-height: 22px;
        margin-right: 26px;
      }
      .actions-num {
        font-size: 28px;
        color: #6982fa;
        line-height: 28px;
        margin-left: 8px;
      }
    }
    .desc {
      margin-top: 20px;
      position: relative;
      height: 520px;
      font-size: 30px;
      color: #21252d;
      line-height: 56px;
      overflow: hidden;
      &::after {
        position: absolute;
        left: 0;
        bottom: -12px;
        content: '';
        display: block;
        width: 650px;
        height: 238px;
        background: linear-gradient(
          180deg,
          rgba(250, 250, 255, 0) 0%,
          rgba(244, 244, 255, 0.91) 64%,
          #f5f6ff 100%
        );
      }
    }
    .more {
      // width: 100%;
      font-size: 22px;
      color: #6c798c;
      line-height: 22px;
      // margin: 29px auto 0;
      // text-align: center;
      position: absolute;
      bottom: 300px;
      left: 50%;
      transform: translateX(-50%);
    }
    .code {
      position: absolute;
      right: 140px;
      bottom: 113px;
      width: 127px;
      height: 140px;
      background: url('~images/platform/dynamicDetail/code-bg.png') no-repeat;
      background-size: 100% 100%;
      padding: 9px 9px 0;
      box-sizing: border-box;
      .code-img {
        width: 108px;
        height: 108px;
      }
    }
    .logo {
      position: absolute;
      left: 90px;
      bottom: 92px;
      .logo-img {
        width: 138px;
        height: 32px;
      }
      .logo-text {
        font-size: 20px;
        color: #6982fa;
        line-height: 24px;
        margin-top: 16px;
      }
    }
  }
}
</style>
